/* eslint-disable jsx-a11y/label-has-associated-control */
import classNames from 'classnames';
import { useId, type HTMLProps } from 'react';

import './checkbox.scss';

export type CheckboxProps = HTMLProps<HTMLInputElement> & {
  error?: { message?: string };
};

export function Checkbox({ className = '', id: originalId, placeholder, error, ...props }: CheckboxProps) {
  const generatedId = useId();
  const id = originalId || generatedId;

  return (
    <div className={classNames('payflow-ui checkbox', className)}>
      <input type="checkbox" id={id} className="checkbox-input" {...props} />
      <label htmlFor={id} className="checkbox-label" />
      {placeholder && <span className="checkbox-placeholder">{placeholder}</span>}
      {error && <span className="invalid-feedback">{error.message}</span>}
    </div>
  );
}
